<div
  class="absolute top-0 bottom-0 left-0 right-0 flex justify-center items-center"
>
  <span class="rounded-angle rounded-angle-top-left"></span>
  <span class="rounded-angle rounded-angle-top-right"></span>
  <span class="rounded-angle rounded-angle-bottom-left"></span>
  <span class="rounded-angle rounded-angle-bottom-right"></span>
  <ng-content></ng-content>
</div>
